import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// @ts-ignore
import { selectRolesArray } from '../../../../services/roles/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectOptions = createDeepEqualSelector(
    [selectRolesArray],
    (rolesState: Record<string, any>): any => {
        return rolesState.map((role: any): any => ({
            key: role.id,
            text: role.name,
            value: `${role.id}`
        }));
    }
);

export { selectOptions };
